export const settings = {
	urls: {
		login: "/login",
		register: "/register",
		forgotPassword: "/forgot-password",
		resetPassword: "/reset-password",
		wines: "/wines",
		subscriptions: "/subscriptions",
		subscription: "/subscription",
		wineClubs: "/wine-clubs",
		collections: "/collections",
		productCollection: "/collection",
		eventBooking: "/event-booking",
		wineEvents: "/events",
		checkout: "/checkout",
		checkoutCompleted: "/wines",
		myAccount: "/my-account",
		orders: "/orders",
		eventBookingDetails: "/event-Booking-Details",
	},
};

export default settings;
